import request from "../utils/request";

export async function getStockOrderList(payload) {
  return new Promise((resolve, reject) => {
    request.get("StockOrder/List", {
      params: {
        sortBy: payload.sortBy,
        sortDirection: payload.sortDirection,
        pageIndex: payload.pageIndex,
        pageSize: payload.pageSize,
        stockOrderId: payload.stockOrder ? payload.stockOrder.id : null,
        status: payload.stockOrderStatus != null ? payload.stockOrderStatus.id : null,
        rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
        stockCode: payload.stockCode,
        branchCode: payload.branchCode,
        variantId : payload.variant != null ? payload.variant.id : null,
        branchId: payload.branch ? payload.branch.id : null,
        startCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.startDate != null ? payload.dateRangeComplete.startDate.toDateString() : null,
        startCreatedDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
        endCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.endDate != null ? payload.dateRangeComplete.endDate.toDateString() : null,
        endCreatedDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      }
    }).then(response => {
      if (response.status != 200) {
        reject(new Error(response.data.message));
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });
  });
}

export async function getStockOrderExcel(payload) {
  return request.get("StockOrder/ListExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      stockOrderId: payload.stockOrder ? payload.stockOrder.id : null,
      status: payload.stockOrderStatus != null ? payload.stockOrderStatus.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      stockCode: payload.stockCode,
      branchCode: payload.branchCode,
      variantId : payload.variant != null ? payload.variant.id : null,
      branchId: payload.branch ? payload.branch.id : null,
      startCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.startDate != null ? payload.dateRangeComplete.startDate.toDateString() : null,
      startCreatedDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      endCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.endDate != null ? payload.dateRangeComplete.endDate.toDateString() : null,
      endCreatedDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
    }
  })
}

export async function getStockOrderExcelWithDetail(payload) {
  return request.get("StockOrder/ListExcelWithDetail", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      stockOrderId: payload.stockOrder ? payload.stockOrder.id : null,
      status: payload.stockOrderStatus != null ? payload.stockOrderStatus.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      stockCode: payload.stockCode,
      branchCode: payload.branchCode,
      variantId : payload.variant != null ? payload.variant.id : null,
      branchId: payload.branch ? payload.branch.id : null,
      startCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.startDate != null ? payload.dateRangeComplete.startDate.toDateString() : null,
      startCreatedDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      endCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.endDate != null ? payload.dateRangeComplete.endDate.toDateString() : null,
      endCreatedDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
    }
  })
}

export async function getStockOrderExcelWithDetailForDealer(payload) {
  return request.get("StockOrder/ListExcelWithDetailForDealer", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      stockOrderId: payload.stockOrder ? payload.stockOrder.id : null,
      status: payload.stockOrderStatus != null ? payload.stockOrderStatus.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      stockCode: payload.stockCode,
      branchCode: payload.branchCode,
      variantId : payload.variant != null ? payload.variant.id : null,
      branchId: payload.branch ? payload.branch.id : null,
      startCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.startDate != null ? payload.dateRangeComplete.startDate.toDateString() : null,
      startCreatedDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      endCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.endDate != null ? payload.dateRangeComplete.endDate.toDateString() : null,
      endCreatedDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
    }
  })
}

export async function getStockOrderExcelForDealer(payload) {
  return request.get("StockOrder/ListForDealerExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      stockOrderId: payload.stockOrder ? payload.stockOrder.id : null,
      status: payload.stockOrderStatus != null ? payload.stockOrderStatus.id : null,
      rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
      stockCode: payload.stockCode,
      branchCode: payload.branchCode,
      variantId : payload.variant != null ? payload.variant.id : null,
      branchId: payload.branch ? payload.branch.id : null,
      startCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.startDate != null ? payload.dateRangeComplete.startDate.toDateString() : null,
      startCreatedDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      endCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.endDate != null ? payload.dateRangeComplete.endDate.toDateString() : null,
      endCreatedDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
    }
  })
}

export async function getStockOrderListForDealer(payload) {
  return new Promise((resolve, reject) => {
    request.get("StockOrder/ListForDealer", {
      params: {
        sortBy: payload.sortBy,
        sortDirection: payload.sortDirection,
        pageIndex: payload.pageIndex,
        pageSize: payload.pageSize,
        stockOrderId: payload.stockOrder ? payload.stockOrder.id : null,
        status: payload.stockOrderStatus != null ? payload.stockOrderStatus.id : null,
        rawMaterialId: payload.rawMaterial ? payload.rawMaterial.id : null,
        stockCode: payload.stockCode,
        branchCode: payload.branchCode,
        variantId : payload.variant != null ? payload.variant.id : null,
        branchId: payload.branch ? payload.branch.id : null,
        startCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.startDate != null ? payload.dateRangeComplete.startDate.toDateString() : null,
        startCreatedDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
        endCompleteDate: payload.dateRangeComplete != null && payload.dateRangeComplete.endDate != null ? payload.dateRangeComplete.endDate.toDateString() : null,
        endCreatedDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      }
    }).then(response => {
      if (response.status != 200) {
        reject(new Error(response.data.message));
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });
  });
}

export async function getEmptyStockOrder() {
  return new Promise((resolve, reject) => {
    request.get("StockOrder/EmptyStockOrder").then(response => {
      if (response.status != 200) {
        reject(new Error(response.data.message));
      }
      resolve(response.data);
    }).catch(e => {
      reject(e);
    });
  });
}

export async function getExcel(payload) {
  return request.get("StockOrder/GetExcel", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      id:payload
    }
  })
}

export async function deleteStockOrder(orderId) {
  return request.delete("StockOrder/Delete?id=" + orderId);
}

export async function deleteStockOrderForDealer(orderId) {
  return request.delete("StockOrder/DeleteForDealer?id=" + orderId);
}

export async function placeNewOrder(payload) {
  convertToIntAllRows(payload);
  return request.post("StockOrder/PlaceStockOrder", payload)
}

export async function createNewStockOrder(payload) {
  convertToIntAllRows(payload);
  return request.post("StockOrder/Create", payload);
}

export async function changeState(payload) {
  return request.post("StockOrder/ChangeState", payload);
}

export async function canceledStockOrder(payload) {
  return request.post("StockOrder/Canceled?id=" + payload);
}

export async function preparingStockOrder(payload) {
  return request.post("StockOrder/Preparing?stockOrderId=" + payload );
}

export async function preparingStockOrderForDealer(payload) {
  return request.post("StockOrder/PreparingForDealer?stockOrderId=" + payload );
}

export async function getOrderEntries(stockOrderId) {
  return request.get("StockOrder/GetOrderEntries?stockOrderId=" + stockOrderId)
}

export async function sendOrder(payload) {
  convertToIntAllRows(payload);
  return request.post("StockOrder/SendOrder", payload);
}

export async function sendOrderForDealer(payload) {
  convertToIntAllRows(payload);
  return request.post("StockOrder/SendOrderForDealer", payload);
}

export async function approveReceive(payload) {
  let obj = {
    id: payload
  };
  return request.post("StockOrder/ApproveReceive", obj);
}

export async function getEntryApproveLogs(payload) {
  return request.get("StockOrder/GetEntryApproveLogs?stockOrderEntryId=" + payload);
}

function convertToIntAllRows(payload) {
  payload.groupes.flatMap(group => group.stocks).map(x => {
    x.modifiedQuantity = parseFloat(x.modifiedQuantity);
    x.quantity = parseFloat(x.quantity);
    return x;
  });
}
